import { PERMISOS, puedeAcceder } from "../servicios/sesionSeguridad";

export const permisosReportes = [
  PERMISOS.REPORTES_VER,
  PERMISOS.REPORTES_VENTAS_VER,
  PERMISOS.REPORTES_INGRESOS_VER,
  PERMISOS.REPORTES_PRODUCCION_VER,
  PERMISOS.REPORTES_DESPACHOS_VER,
  PERMISOS.REPORTES_STOCK_VER,
  PERMISOS.REPORTES_CAJA_VER,
  PERMISOS.COMPROBANTES_VER,
  PERMISOS.NOTAS_CREDITO_VER,
  PERMISOS.CUENTA_CORRIENTE_VER,
  PERMISOS.TRAZABILIDAD_VER,
];

export const gruposNavegacion = [
  {
    id: "operaciones",
    titulo: "Gestión de producción",
    descripcion: "Registrá movimientos de planta y entregas.",
    ruta: "/gestion-produccion",
    icono: "pi-box",
    opciones: [
      { label: "Ingresos a planta", descripcion: "Registrá la entrada de mercadería.", ruta: "/ingreso-planta", icono: "pi-sign-in", permiso: PERMISOS.PRODUCCION_ADMINISTRAR },
      { label: "Producción", descripcion: "Gestioná entradas y salidas del proceso productivo.", ruta: "/produccion", icono: "pi-box", permiso: PERMISOS.PRODUCCION_ADMINISTRAR },
      { label: "Despachos", descripcion: "Prepará y controlá las entregas.", ruta: "/despachos", icono: "pi-truck", permiso: PERMISOS.PEDIDOS_ADMINISTRAR },
    ],
  },
  {
    id: "ventas",
    titulo: "Ventas",
    descripcion: "Registrá la actividad comercial.",
    ruta: "/centro-ventas",
    icono: "pi-shopping-cart",
    opciones: [
      { label: "Ventas", descripcion: "Realizá una nueva venta.", ruta: "/pos", icono: "pi-shopping-cart", permiso: PERMISOS.VENTAS_VER },
    ],
  },
  {
    id: "consultas",
    titulo: "Consultas",
    descripcion: "Analizá información de todas las áreas.",
    ruta: "/centro-consultas",
    icono: "pi-chart-bar",
    opciones: [
      { label: "Reportes", descripcion: "Consultá toda la actividad del negocio.", ruta: "/reportes", icono: "pi-chart-bar", permisos: permisosReportes },
    ],
  },
  {
    id: "configuracion",
    titulo: "Catálogo y configuración",
    descripcion: "Mantené actualizados productos, precios y accesos.",
    ruta: "/catalogo-configuracion",
    icono: "pi-cog",
    opciones: [
      { label: "Listas de precios", descripcion: "Actualizá precios y listas comerciales.", ruta: "/listas-precios", icono: "pi-tags", permiso: PERMISOS.PRECIOS_VER },
      { label: "Puntos de venta", descripcion: "Configurá los puntos de venta habilitados.", ruta: "/puntos-venta", icono: "pi-map-marker", permiso: PERMISOS.CONFIGURACION_ADMINISTRAR },
      { label: "Seguridad", descripcion: "Administrá usuarios, roles y permisos.", ruta: "/seguridad", icono: "pi-shield", permisos: [PERMISOS.USUARIOS_ADMINISTRAR, PERMISOS.SEGURIDAD_ADMINISTRAR] },
    ],
  },
];

export const opcionPermitida = (opcion) => {
  if (opcion.permisos) {
    return opcion.permisos.some((permiso) => puedeAcceder(permiso));
  }

  return !opcion.permiso || puedeAcceder(opcion.permiso);
};

export const obtenerGruposPermitidos = () =>
  gruposNavegacion
    .map((grupo) => ({
      ...grupo,
      opciones: grupo.opciones.filter(opcionPermitida),
    }))
    .filter((grupo) => grupo.opciones.length > 0);
